import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
import { mapActions, mapState } from "pinia";
import { usePaymentStore } from "%/dynamic-component-editor/stores/payments-store";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import { useDigitalProductStore } from "%/dynamic-component-editor/stores/digital-product-store";

// Frozen empty placeholder so element computeds reading `entity.X`
// don't throw while the real fetch is in flight on the production
// canvas. All numeric/string fields the DP-card elements touch.
const EMPTY_DIGITAL_PRODUCT_ENTITY = Object.freeze({
  digitalProductId: 0,
  type: "",
  name: "",
  description: "",
  price: "0",
  currencyCode: "USD",
  creatorOrgId: 0,
  publicationId: 0,
  startAvailableForPurchaseTimestamp: 0,
  endAvailableForPurchaseTimestamp: 0,
  status: "",
  timestampCreated: 0,
  timestampUpdated: 0,
});

export const DigitalProductCardElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  inject: {
    pageEntities: { default: null },
    useExampleData: { default: () => () => false },
  },
  entityStore: () => useDigitalProductStore(),
  created() {
    if (this.editMode || this.isPreviewMode) {
      return;
    }
    const id = this.digitalProductEntityId;
    if (!id) {
      return;
    }
    useDigitalProductStore().getOrFetchDigitalProduct(id);
  },
  computed: {
    ...mapState(usePaymentStore, ["loading", "currentEntityId"]),
    isLoadingBuyDigitalProduct() {
      return this.loading?.createOneTimeCheckoutSession && this.currentEntityId === this.entityId;
    },
    isPreviewMode() {
      const fn = this.useExampleData;
      return typeof fn === "function" ? Boolean(fn()) : Boolean(fn);
    },
    digitalProductEntityId() {
      if (this.entityId !== undefined && this.entityId !== null && this.entityId !== 0 && this.entityId !== "0") {
        return this.entityId;
      }
      const fromPage = typeof this.pageEntities === "function" ? this.pageEntities()?.digitalProduct : this.pageEntities?.digitalProduct;
      return fromPage ?? 0;
    },
  },
  methods: {
    ...mapActions(usePaymentStore, ["createOneTimeCheckoutSession"]),
    getExampleEntity() {
      return {
        digitalProductId: 0,
        type: "access",
        name: "Premium Membership",
        description: "Unlock exclusive articles, videos, and community features",
        price: "9.990",
        currencyCode: "USD",
        creatorOrgId: 0,
        publicationId: 0,
        startAvailableForPurchaseTimestamp: 0,
        endAvailableForPurchaseTimestamp: 0,
        status: "active",
        timestampCreated: 0,
        timestampUpdated: 0,
      };
    },
    getRealEntity() {
      if (this.isPreviewMode) {
        return this.getExampleEntity();
      }
      const id = this.digitalProductEntityId;
      if (!id) {
        return EMPTY_DIGITAL_PRODUCT_ENTITY;
      }
      const cached = useDigitalProductStore().digitalProducts?.[id];
      if (cached && (cached.digitalProductId || cached.digital_product_id)) {
        return cached;
      }
      return EMPTY_DIGITAL_PRODUCT_ENTITY;
    },
    buyDigitalProduct() {
      this.createOneTimeCheckoutSession(
        this.entity?.stripePriceId,
        this.entity?.digitalProductId,
        this.entity?.creatorOrgId,
        this.entity?.publicationId,
        this.entityId,
        window.location.href,
      );
    },
    viewDigitalProductDetails() {
      window.location.href = `${useGeneralStore().links.web}/digital-product-details/${this.entityId}`;
    },
    downloadDigitalProduct() {
      window.location.open = this.entity?.downloadUrl;
    },
  },
};
